import { isArray } from "lodash";
import React from "react";

const PageHeader = ({ title, subTitle = "", extra, wrapperClasses = "" }) => {
  return (
    <div className={`flex justify-between items-center mb-4 ${wrapperClasses}`}>
      <div>
        <h2 className="text-2xl font-bold app-text">
          {title}
        </h2>
        {subTitle && <p className="app-muted mt-1">{subTitle}</p>}
      </div>
      {isArray(extra) && extra.length > 0 && (
        <div className="flex gap-2">{extra.map((Item) => Item)}</div>
      )}
    </div>
  );
};

export default PageHeader;
